import { render, staticRenderFns } from "./Acta.vue?vue&type=template&id=324f1890&"
import script from "./Acta.vue?vue&type=script&lang=js&"
export * from "./Acta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports